// extracted by mini-css-extract-plugin
export default {"fancyInlineEdit":"FancyInlineEdit_fancyInlineEdit__rYoWI","fancyInlineEditTextArea":"FancyInlineEdit_fancyInlineEditTextArea__bWO3A"};